import {RegisterOptions} from 'react-hook-form';

type RegisterRules = {
    disabled?: boolean;
    markOptional?: boolean;
    required?: boolean | string;
    rules?: {
        markOptional?: boolean;
    } & RegisterOptions;
};

export const getRegisterRules = ({
    disabled,
    markOptional,
    required,
    rules,
}: RegisterRules) => {
    if (rules) {
        return rules;
    }
    const result: RegisterRules = {};

    if (disabled) {
        result['disabled'] = disabled;
    }
    if (markOptional) {
        result['markOptional'] = markOptional;
    }

    if (required) {
        result['required'] = required;
    }
    return result;
};
